import PageComponent from '../base/PageComponent';
import 'bootstrap';

export default class Tab extends PageComponent {

    init() {

    }
}



// WEBPACK FOOTER //
// ./javascript/components/Tab.js